import React, { useEffect, useState } from "react";

export default function ListUsers() {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [search, setSearch] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const USERS_PER_PAGE = 5;

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(1);
            // setUsers([]);
            setSearch(searchTerm);
        }, 500); // debounce input

        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);

    useEffect(() => {
        fetchUsers(page, search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, search]);

    const fetchUsers = async (currentPage, search) => {
        setLoading(true);
        setError("");
        if (currentPage === 1) {
            setUsers([]); // clear users only here, right before fetch
        }
        const token = sessionStorage.getItem("token");
        try {
            const res = await fetch(
                `${process.env.REACT_APP_BASE_URL}cc/r/users?page=${currentPage}&limit=${USERS_PER_PAGE}&search=${encodeURIComponent(search)}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) throw new Error(`Server error: ${res.status}`);

            const data = await res.json();

            if (!Array.isArray(data.users)) {
                throw new Error("Invalid response");
            }

            setUsers((prev) =>
                currentPage === 1 ? data.users : [...prev, ...data.users]
            );
            setHasMore(data.hasMore);
        } catch (err) {

            setError("Failed to load users. Please try again.");
        }

        setLoading(false);
    };
    useEffect(() => {

    }, [users]);
    const handleRetry = () => {
        fetchUsers(page, search);
    };

    return (
        <div>
            <h2 className="text-center mb-2 mt-4">List of Users</h2>
            {/* <h4 className="mb-3"></h4> */}

            {/* Search Input */}
            <div className="mb-3">
                <input
                    className="form-control"
                    type="text"
                    placeholder="Search users..."
                    maxLength={25}
                    minLength={1}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z0-9\s.-]*$/.test(value)) {
                            setSearchTerm(value);
                        }
                    }}
                />
            </div>

            {/* User List */}
            <ul className="list-group mb-3">
                <li style={{ listStyleType: "none" }}>
                    <div className="d-flex flex-row justify-space-even mb-2">
                        <div className="w-100 text-center">
                            <strong>username</strong>
                        </div>
                        <div className="w-100 text-center">
                            <strong>creation time</strong>
                        </div>
                        <div className="w-100 text-center">
                            <strong>status</strong>
                        </div>
                    </div>
                </li>
                {users.map((user) => (
                    <li key={user.user} className="list-group-item">
                        <div className="d-flex flex-row justify-space-even align-items-center">
                            <div className="w-100 text-center">
                                <strong>{user.user}</strong>
                            </div>
                            <div className="w-100 text-center">
                                <strong>{user.created}</strong>
                            </div>
                            <div className={`w-100 text-center ${user.status === "active" ? 'text-green' : 'text-red'}`}>
                                <strong>{user.status}</strong>
                            </div>

                        </div>



                    </li>
                ))}
            </ul>

            {/* Skeleton Loader */}
            {loading && (
                <div className="mb-3">
                    {[...Array(USERS_PER_PAGE)].map((_, i) => (
                        <div key={i} className="list-group-item placeholder-glow">
                            <span className="placeholder col-6"></span>
                        </div>
                    ))}
                </div>
            )}

            {/* Error State */}
            {error && (
                <div className="alert alert-danger d-flex justify-content-between align-items-center">
                    {error}
                    <button className="btn btn-sm btn-outline-light" onClick={handleRetry}>
                        Retry
                    </button>
                </div>
            )}

            {/* Load More Button */}
            {!loading && hasMore && (
                <button
                    className="btn btn-load"
                    onClick={() => setPage((prev) => prev + 1)}
                >
                    Load More
                </button>
            )}

            {/* End of List Message */}
            {!hasMore && users.length > 0 && !loading && (
                <div className="text-muted">All users loaded</div>
            )}

            {/* No Users Found */}
            {!loading && users.length === 0 && !error && (
                <div className="text-muted">No users found</div>
            )}
        </div>
    );
}
